import { render } from "./TwcPopup.vue?vue&type=template&id=33331e54&scoped=true"
import script from "./TwcPopup.vue?vue&type=script&lang=js"
export * from "./TwcPopup.vue?vue&type=script&lang=js"

import "./TwcPopup.vue?vue&type=style&index=0&id=33331e54&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33331e54"]])

export default __exports__